import Page from "@/components/pages/inventory/live";
import { createFileRoute } from "@tanstack/react-router";


export const Route = createFileRoute("/_app/inventory/live/_modal/")({
  component: Page,
});
